import type { FaireProductEntity } from "../../entity_types/product";

export const p_yy97ha4dcz: FaireProductEntity = {
  token: "p_yy97ha4dcz",
  type: "product",
  name: "Hair Conditioner Refill",
  brandToken: "b_1stl3gkk5n",
  brandName: "Bubbsi",
  imageUrl: "https://cdn.faire.com/fastly/ec4aeef7f4775f4daaa062a6e4fd9f8bfce6b1b33923bfa9e5d4872132ca7fb9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9b6e5b430c7b63f56481b0d24ec96f28203ea604219cb8e2f9cf5a4f2a0e5414.jpeg",
    "https://cdn.faire.com/fastly/8af6105b5eff65e095d6ce4eb2423a6c8c5834f3becec358b00bb629a985fb0d.jpeg",
    "https://cdn.faire.com/fastly/93a56954fc5e6fc131507e0607fd842cc07aff3895cc8c535aaa1830dfb8f2e7.jpeg",
    "https://cdn.faire.com/fastly/a67fd8b6ac00520eeb8950f66fc19c94f2f3a80fb8f0fb8b0c33f2d2f815cab0.jpeg",
    "https://cdn.faire.com/fastly/d3a8980b035899e28ead337e81692c37f53188729b0275d3482f413edad3645f.jpeg"
  ],
  priceDollars: 36,
  description: "Refill your 8oz kitty bottle four times with this bulk size of our Creamy Coconut Oil Hair Conditioner - a rich and luxurious formula that is good enough for your own hair, but made for your little ones to love.\n\nOur hair conditioner nourishes dry scalp and dry hair, and tames even the knottiest of strands. Organic Coconut Oil and Shea Butter provide deep moisture, while plant-based conditioners detangle, reduce frizz and add shine, leaving scalp and strands feeling purrrfectly soft.\n\nThis rich vegan formula soothes itchy, flaky scalp, tackles dandruff, and restores parched, dry hair. Will not irritate eyes, and washes out cleanly without weighing hair down.\n\nSAFE FOR EVEN THE LITTLEST BUBS:\n*96% naturally derived, vegan formula\n*EU compliant\n*Light all-natural scent: Coconut, vanilla and a spoonful of giggles\n*No parabens, phthalates, sulfates, mineral oils, or dyes\n*Allergy, Dermatologist & Pediatrician Tested",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:30.850Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
